import { TMenuLeaf } from '../components/types';
import {
    DASHBOARD_APPOINTMENTS_REPORT_AUTH,
    DASHBOARD_GENERAL_REPORT_AUTH,
    DASHBOARD_GOALS_REPORT_AUTH,
    DASHBOARD_SALES_REPORT_AUTH,
    DASHBOARD_VISITS_REPORT_AUTH,
} from 'src/constants/permissions';

export const DASHBOARD_MENU: TMenuLeaf[] = [
    {
        title: 'Navbar.Principal',
        path: '/dashboards/general',
        permission: DASHBOARD_GENERAL_REPORT_AUTH,
    },
    {
        title: 'Reports.DASHBOARD_GOALS_REPORT_AUTH',
        path: '/dashboards/goals',
        permission: DASHBOARD_GOALS_REPORT_AUTH,
        tooltip: 'Reports.DASHBOARD_GOALS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Navbar.Appointments',
        path: '/dashboards/appointments',
        permission: DASHBOARD_APPOINTMENTS_REPORT_AUTH,
    },
    {
        title: 'Navbar.Visits',
        path: '/dashboards/visits',
        permission: DASHBOARD_VISITS_REPORT_AUTH,
    },
    {
        title: 'Navbar.Financing',
        path: '/dashboards/sales',
        permission: DASHBOARD_SALES_REPORT_AUTH,
    },
];
